/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { formatPhone } from '../../utils';

const shippingAddressState = (state) => state.cart?.shippingAddress;
const { customerId, customerAddress } = (state) => state.accounts;

export const selectShippingAddress = createSelector([shippingAddressState], (shippingAddress) => ((
  shippingAddress &&
  Object.keys(shippingAddress).length
) ?
  {
    ...shippingAddress,
    streetAddress: shippingAddress.streetName,
    phone: formatPhone(shippingAddress.phone ?? ''),
    email: customerId ? customerAddress.email : shippingAddress.email,
  } :
  (shippingAddress ?? {})));
